// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2301":"5277e5e98efc843f","6533":"61b4c9334f43ec3a","13678":"57cb0da95d0342cc","60657":"1bd95b5a858d1212","80082":"e8dec7efcdc6dc08"}[chunkId] + ".css";
};